import { render, staticRenderFns } from "./FacebookConfiguration.vue?vue&type=template&id=5723a026&"
import script from "./FacebookConfiguration.vue?vue&type=script&lang=js&"
export * from "./FacebookConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports